import { render, staticRenderFns } from "./formelement_disabled.vue?vue&type=template&id=bfa20aca&"
import script from "./formelement_disabled.vue?vue&type=script&lang=js&"
export * from "./formelement_disabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports